import { withTheme } from 'emotion-theming'
import { useState, useRef } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import PlusIcon from 'public/icons/plus.svg'
import MinusIcon from 'public/icons/minus.svg'

import style from './Accordion.style'

const AccordionStyled = styled.div(props => ({ ...style(props) }))

const AccordionComponent = ({ title, text }) => {
    const [setActive, setActiveState] = useState('')
    const [setHeight, setHeightState] = useState('0px')

    const content = useRef(null)

    function toggleAccordion() {
        setActiveState(setActive === '' ? 'active' : '')
        setHeightState(setActive === 'active' ? '0px' : `${content.current.scrollHeight}px`)
    }

    return title ? (
        <AccordionStyled>
            <div className="AccordionItem">
                <button type="button" className={`Button ${setActive}`} onClick={toggleAccordion}>
                    <p className="Title">{title}</p>
                    <div className="IconSet">
                        <PlusIcon className="plus" />
                        <MinusIcon className="minus" />
                    </div>
                </button>
                <div ref={content} style={{ maxHeight: `${setHeight}` }} className="Content">
                    {/* eslint-disable react/no-danger */}
                    <div className="Text" dangerouslySetInnerHTML={{ __html: text }} />
                </div>
            </div>
        </AccordionStyled>
    ) : null
}

AccordionComponent.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string
}

AccordionComponent.defaultProps = {
    title: undefined,
    text: undefined
}

export default withTheme(AccordionComponent)
